
        import 'CapturePaymentDetails.ede60fd.css-module'
        export default {"form":"form_CapturePaymentDetails_ede60fd"}
    